import { render, staticRenderFns } from "./grainMarket.vue?vue&type=template&id=b16b2d0e&scoped=true"
import script from "./grainMarket.vue?vue&type=script&lang=js"
export * from "./grainMarket.vue?vue&type=script&lang=js"
import style0 from "./grainMarket.vue?vue&type=style&index=0&id=b16b2d0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16b2d0e",
  null
  
)

export default component.exports